<!--
 * @Description: file content
 * @Author: liujunyao
 * @Date: 2022-03-28 13:50:51
 * @LastEditors: shayne
 * @LastEditTime: 2023-03-17 11:25:27
 * @FilePath: /privacy-web/src/components/The/Thefiling.vue
-->
<template>
  <div class="filing" :class="{ 'filing-mobile': isMobile }">
    © Copyright {{ new Date().getFullYear() }} ke.com | 津ICP备18000836号
  </div>
</template>
<script>
export default { name: "TheFiling" };
</script>
<style lang="scss" scoped>
.filing {
  height: calc($multiple * 72px);
  font-size: calc($multiple * 14px);
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: calc($multiple * 72px);
  letter-spacing: 1px;
  text-align: center;
  position: relative;
  &::before {
    content: "";
    width: calc($multiple * 1040px);
    height: 1px;
    background: #ffffff;
    opacity: 0.11;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
  }
}
.filing-mobile {
  height: 2.87rem;
  line-height: 2rem;
  font-size: 0.45rem;
  &::before {
    width: 17.15rem;
  }
}
</style>
